export default __webpack_public_path__ + "static/media/Contact.dfee2775.gif";